import { FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function FrameBuilderIntro() {
    const navigate = useNavigate();

    const handleSubmit = () => {
        navigate('/frameBuilder');
    }

    return (
        <div
            className="min-h-screen bg-cover bg-center flex flex-col justify-center items-center text-white text-center px-6 py-8 overflow-y-auto"
            style={{ backgroundImage: "url('/images/bg.jpg')" }}>
            <div className="flex flex-col justify-center items-center max-w-6xl w-full">
                <img src="/images/logo.png" alt="logo" className="max-w-[150px] mb-5" />
                <h2 className='text-3xl font-bold mb-4'>Dear Frame Surgeon Colleague,</h2>
                <p className="text-base mb-5 max-w-[1000px] leading-7">
                    This website is created to help you plan and document your circular frame construct. It is simple to use to build a frame graphic in a methodical way - enter the patient details (keeping confidentiality in mind), a brief description of indication and side and start building. There are interactive panels on the left side which have all the graphic assets you need to construct a circular frame on Tibia and Fibula only. Femur and upper limb modules are not included at this stage. It is a simple drag and drop interactive builder and at the end of it you can print or save a PDF of the completed frame for teaching and or documentation (in operation notes for example) purposes. Please note that only a non-deformed tibia and fibula models are included. You can mark the site of the fracture or deformity using a pen tool. The levels indicated on the diagrams on the left and right side of the top of the page are standard llizarov atlas levels and corresponding cross sections of the limb are included in assets. I have included various transosseous elements which can be dragged and aligned in the desired position to complete a frame. I have included llizarov Frame and Maxframe Hexapod options only. Please note that this is graphic tool only and you are responsible for performing surgery. This is for guidance only. Thank you for using this website and your valuable feedback is welcome at
                    <br />
                    <>
                        <a href="mailto:Builderfeedback@icloud.com" className='hover:underline'>
                            Builderfeedback@icloud.com.
                        </a>
                    </>
                </p>
                <div className="flex gap-3">
                    <div
                        onClick={handleSubmit}
                        className="flex gap-1 items-center bg-[#49bef3] hover:bg-blue-700 text-white py-2 px-6 rounded-full text-base border-2 border-blue-500 justify-center cursor-pointer transition-colors">
                        <FileText size={25} />
                        <span>Start building a circular frame</span>
                    </div>
                </div>
            </div>
        </div>
    );
}